/**
 * Varför kunde en lägenhet inte kontrolleras i avvikelserapporten?
 *
 * Rapporten klumpade tidigare ihop tre helt olika saker under rubriken
 * "Kunde inte kontrolleras". Föreningen kunde därför inte se vad de själva
 * kan rätta till (lägenhetsnummer i medlemsförteckningen) och vad som är ett
 * driftsproblem hos oss (misslyckat adressuppslag).
 */

export const UNCHECKED_REASON = {
  MISSING_APARTMENT_NUMBER: 'MISSING_APARTMENT_NUMBER',
  NO_REGISTRY_MATCH: 'NO_REGISTRY_MATCH',
  API_ERROR: 'API_ERROR',
};

export const UNCHECKED_REASON_META = {
  [UNCHECKED_REASON.MISSING_APARTMENT_NUMBER]: {
    label: 'Lägenhetsnummer saknas i medlemsförteckningen',
    description:
      'Utan lägenhetsnummer går det inte att matcha medlemmen mot folkbokföringen. Komplettera medlemsförteckningen så kontrolleras lägenheten vid nästa körning.',
    fixableByAssociation: true,
  },
  [UNCHECKED_REASON.NO_REGISTRY_MATCH]: {
    label: 'Lägenhetsnumret matchar inte folkbokföringen',
    description:
      'Lägenhetsnumret finns i medlemsförteckningen men ingen folkbokförd hittades på det. Kontrollera att numret är skrivet som Skatteverkets fyrsiffriga lägenhetsnummer.',
    fixableByAssociation: true,
  },
  [UNCHECKED_REASON.API_ERROR]: {
    label: 'Adressuppslaget misslyckades',
    description:
      'Folkbokföringsdata kunde inte hämtas för adressen. Det är ett tekniskt fel hos oss — kör rapporten igen senare.',
    fixableByAssociation: false,
  },
};

/**
 * @param {object|null} result Rad ur apartmentResults.
 * @returns {string|null} Orsak, eller null om lägenheten faktiskt kontrollerades.
 */
export function classifyUncheckedResult(result) {
  if (!result) return null;

  if (result.verdict === 'API_ERROR') return UNCHECKED_REASON.API_ERROR;
  if (result.verdict !== 'NO_DATA') return null;

  const apartmentNumber = (result.apartmentNumber || '').toString().trim();
  return apartmentNumber
    ? UNCHECKED_REASON.NO_REGISTRY_MATCH
    : UNCHECKED_REASON.MISSING_APARTMENT_NUMBER;
}

/**
 * Delar upp okontrollerade lägenheter per orsak. Alla grupper finns alltid
 * med, även tomma, så anroparen slipper undefined-kontroller.
 */
export function groupUncheckedResults(results = []) {
  const groups = Object.values(UNCHECKED_REASON).reduce((acc, reason) => {
    acc[reason] = [];
    return acc;
  }, {});

  results.forEach((result) => {
    const reason = classifyUncheckedResult(result);
    if (reason) groups[reason].push(result);
  });

  return groups;
}
